import { useEffect, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { dateFromString, dateToDateTime } from '../../utils/date'
import FechaSelector from '../../components/form/FechaSelector/FechaSelector'
import AcademiaSelector from '../../components/form/AcademiaSelector/AcademiaSelector'
import TipoEventoSelector from '../../components/form/TipoEventoSelector/TipoEventoSelector'
import css from './ModalEventoCalendario.module.css'

const EventoIcon = ({ evento }) => {
  if (!evento || !evento.tipo) return null
  return (
    <i className='material-icons'>
      {evento.tipo === 'AVISO' && 'info'}
      {evento.tipo === 'NOTIFICACION' && 'notifications'}
      {evento.tipo === 'RECORDATORIO' && 'alarm'}
      {evento.tipo === 'ALERTA' && 'warning'}
    </i>
  )
}

const ModalEventoCalendario = ({ open, evento, onClose }) => {
  const [data, setData] = useState({
    titulo: '',
    descripcion: '',
    fecha: null,
    centros: [],
    tipo: ''
  })

  useEffect(() => {
    if (!evento) return
    setData({
      titulo: evento.titulo,
      descripcion: evento.descripcion,
      fecha: dateToDateTime(dateFromString(evento.fecha)),
      centros: evento.centros,
      tipo: evento.tipo
    })
  }, [evento])

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle className={css.title}>
        <EventoIcon evento={evento} />
        {evento?.titulo}
      </DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Evento creado por <strong>{evento?.creador}</strong>.
        </DialogContentText>
        <TextField
          className={css.input}
          value={data.titulo}
          label='Título'
          variant='standard'
        />
        <TipoEventoSelector
          className={css.input}
          name='tipo'
          label='Tipo de evento'
          value={data.tipo}
        />
        <FechaSelector className={css.input} label='Fecha' value={data.fecha} />
        <AcademiaSelector
          multiple
          className={css.input}
          name='academia'
          label='Academias'
          value={data.centros}
        />
        <TextField
          className={css.input}
          value={data.descripcion}
          label='Descripción'
          multiline
          variant='standard'
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEventoCalendario
